import React from "react";
import HeadTittle from "../../../../components/HeadTittle";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import { EditIcon } from "../../../../components/buttons/IconButtons";
import { permissionObj } from "../../../../Helpers/permission";
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import { STEPS_UPDATE_WORK_SHIFT } from "./Model/Models";
import { UpdateWorkShiftApp } from "./Functionality/UpdateWorkShiftApp";
import SectionWorkShift from "./Subcomponents/Steps/SectionWorkShift";
import SectionCustomAccess from "./Subcomponents/Steps/SectionCustomAccess";
import SectionDepartments from "./Subcomponents/Steps/SectionDepartments";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Update work shift flow. Shows the three sections; a single header action
 * resubmits the name + resource ids (schedules persist on their own section).
 */
const UpdateWorkShift = () => {

    const {
        id,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        schedules, setSchedules,
        selectDeleteSchedules, setSelectDeleteSchedules,
        searchElement,
        setSearchElement,
        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,
        modified, setModified,
        user, setUser,
        selectDeleteUser, setSelectDeleteUser,

        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleAddEdit,
        handleOnBack,
    } = UpdateWorkShiftApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={disabled ? 'details' : 'update'}>
                {(DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_UPDATE)) &&
                    <div className='col-12 d-flex justify-content-end gap-2 flex-wrap mb-4'>
                        <ButtonAction
                            id={'btn_ews_update_data'}
                            name='update'
                            className='btn-icon-edit'
                            Icon={EditIcon}
                            onClick={() => handleAddEdit()}
                        />
                    </div>
                }
            </HeadTittle>

            <StepperTabs
                id={id}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_UPDATE_WORK_SHIFT.WORK_SHIFT.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_WORK_SHIFT.WORK_SHIFT.INDEX && (
                        <SectionWorkShift
                            id={id}
                            item={item}
                            handleChange={handleChange}
                            emptyFields={emptyFields}
                            disabled={disabled}
                            schedules={schedules}
                            setSchedules={setSchedules}
                            selectDeleteSchedules={selectDeleteSchedules}
                            setSelectDeleteSchedules={setSelectDeleteSchedules}
                            modified={modified}
                            setModified={setModified}
                        />
                    )}
                </StepTab>

                <StepTab index={STEPS_UPDATE_WORK_SHIFT.CUSTOM_ACCESS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_WORK_SHIFT.CUSTOM_ACCESS.INDEX && (
                        <SectionCustomAccess
                            id={id}
                            disabled={disabled}
                            user={user}
                            setUser={setUser}
                            selectDeleteUser={selectDeleteUser}
                            setSelectDeleteUser={setSelectDeleteUser}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                        />
                    )}
                </StepTab>

                <StepTab index={STEPS_UPDATE_WORK_SHIFT.DEPARTMENTS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_WORK_SHIFT.DEPARTMENTS.INDEX && (
                        <SectionDepartments
                            id={id}
                            disabled={disabled}
                            departments={departments}
                            setDepartments={setDepartments}
                            selectDeleteDepartments={selectDeleteDepartments}
                            setSelectDeleteDepartments={setSelectDeleteDepartments}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default UpdateWorkShift
